import { React, useState } from "react";
import { Check, DollarSign, HelpCircle } from "react-feather";
import { useSelector } from "react-redux";
import axios from "axios";
import download from "downloadjs";

import env from "../../../../env";
import { base64 } from "../../../../constants/validate";

import { useSnackbar } from "../../../../hooks/useSnackbar";

import { Button } from "../../../../components/DesignSystem";
import SectionHeader from "../SectionHeader";

import "./index.scss";
import PaymentCard from "../../../../components/PaymentCard";

export default function AgreementConfirmation() {
  const [isLoadingBillets, setIsLoadingBillets] = useState(false);
  const [isLoadingMinute, setIsLoadingMinute] = useState(false);
  const { payment, debtInfo } = useSelector((state) => state.charge);
  const snackbar = useSnackbar();
  const {
    numberInstallments,
    valueInstallments,
    total,
    paymentType,
    paymentWay,
  } = payment;
  let totalWithFees = 0;

  console.log(debtInfo);
  if (payment.paymentType === "credit") {
    totalWithFees = payment.numberInstallments * payment.valueInstallments;
  }

  async function handleDownloadBillets() {
    setIsLoadingBillets(true);
    try {
      const response = await axios.get(`/case/download-billets/${debtInfo.id}`);
      const file = window.atob(response.data);
      download(file, "Boleto", "application/pdf");
    } catch (error) {
      console.log(error);
      snackbar("Houve um erro ao baixar os boleto");
    } finally {
      setIsLoadingBillets(false);
    }
  }

  function getLink(){

    setIsLoadingMinute(true);
    axios
      .get("docusign/get-link/"+debtInfo.id)
      .then((response) => {
        window.open(response.data.url, "_blank");
        setIsLoadingMinute(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoadingMinute(false);
      });

  }

  function downloadMinute() {
    setIsLoadingMinute(true);
    let url = `https://d2rb0y5okx0dfh.cloudfront.net/minutes-sign/${debtInfo.id}/${debtInfo.id}.zip`;
    window.open(url, "_blank");
    setIsLoadingMinute(false);
    
    // let token =
    //   env === "development"
    //     ? "830b013e0b3a4112b20db7673bfb303d"
    //     : "93787308c6904130959e60dc4af0e379";
    // let headers = { headers: { token } };
    // axios
    //   .get(debtInfo.documentUrl, headers)
    //   .then((response) => {
    //     download(
    //       base64(response.data.bytes),
    //       response.data.name,
    //       response.data.mimeType
    //     );
    //     setIsLoadingMinute(false);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoadingMinute(false);
    //   });
  }

  function checkCaseCompleted() {
    return debtInfo.status === "PAID";
  }


  function disabledButton(){
    // Assinar minuta
    if ( (debtInfo.missingSignatures == 1) && (debtInfo.minute_signed == 0))
      return false;
    // Baixar contrato assinado
    if ( (debtInfo.missingSignatures == 0) && (debtInfo.minute_signed == 1))
      return false;
    // Aguardando demais assinaturas
    if ( (debtInfo.missingSignatures !== 0) && (debtInfo.minute_signed == 1))
      return true;
  }


  return (
    <div className="agreement-information">
      <SectionHeader>
        <div className="agreement-information__header">
          <h2>
            <Check />{" "}
            {checkCaseCompleted()
              ? "Caso concluído"
              : "Proposta de pagamento validada com sucesso"}
          </h2>
          {!checkCaseCompleted() && (
            <p>
              Clique nos botões abaixo para fazer o download do boleto de
              pagamento e para assinar a minuta.
            </p>
          )}
        </div>
      </SectionHeader>
      <main>
        <div className="agreement-information__payment">
          <p>Pagamento</p>
          <PaymentCard
            type="review"
            typePayment={paymentType === "credit" ? "Parcelado" : "À vista"}
            way={paymentWay}
            total={paymentType === "credit" ? totalWithFees : Number(total)}
            numberInstallments={numberInstallments}
            valueInstallments={Number(valueInstallments)}
            minHeight="150px"
          />
        </div>
        <div className="agreement-information__hints">
          <p>Importante</p>
          {numberInstallments > 1 && (
            <div className="agreement-information__hint">
              <div>
                <DollarSign />
              </div>
              <p>
                Os boletos de pagamento das próximas parcelas estarão
                disponíveis no{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://cn.br-petrobras.com.br/login/login.jsf"
                >
                  Canal de Negócios
                </a>{" "}
                da VIBRA, após assinatura do contrato.
              </p>
            </div>
          )}
          <div className="agreement-information__hint">
            <div>
              <HelpCircle />
            </div>
            <p>
              Caso possua alguma dúvida, entre em contato através do email{" "}
              <a href="mailto: pagdeal@vibraenergia.com.br">
                pagdeal@vibraenergia.com.br
              </a>
            </p>
          </div>
        </div>
      </main>
      <footer>

        <Button
          contained
          type="button"
          fullWidth
          loading={isLoadingMinute}
          onClick={() =>
            debtInfo.missingSignatures === 0 && debtInfo.documentUrl
              ? downloadMinute()
              : getLink() 
          }
          // disabled={
          //   (debtInfo.missingSignatures > 0 &&
          //     debtInfo.missingSignatures < 5 && debtInfo.documentUrl) ||
          //   (debtInfo.missingSignatures === 0)
          // }
          disabled={disabledButton()}
        >
          {debtInfo.missingSignatures === 0 && debtInfo.minute_signed === 1
            ? "Baixar contrato assinado"
            : debtInfo.missingSignatures === 0 && debtInfo.minute_signed === 0
              ? "Aguardando contrato"
              : debtInfo.missingSignatures < 5 &&
                debtInfo.missingSignatures > 0 &&
                debtInfo.minute_signed === 1
                ? "Aguardar demais assinaturas"
                : "Assinar minuta"}
        </Button>
        {!checkCaseCompleted() && (
          <Button
            outlined
            type="button"
            fullWidth
            icon="Download"
            sizeIcon={16}
            loading={isLoadingBillets}
            onClick={() => handleDownloadBillets()}
          >
            Baixar boleto
          </Button>
        )}
      </footer>
    </div>
  );
}
